import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Alert, Spin } from "antd";
import { BACKEND_URL } from "../../../../config/config";
import axios from "axios";
import { ButtonLink } from "../../../misc/button/Button";
import PropTypes from "prop-types";

const styles = {
  title: {
    marginBottom: 30,
  },
  image: {
    width: "50%",
    marginTop: 30,
  },
  infoDiv: {
    margin: "0 0 10px 0",
  },
  checkbox: {
    fontSize: "1rem",
  },
  buttonDiv: {
    width: "100%",
    display: "flex",
  },
};

export default function DeclarationCBPageV2() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const data = state?.message;
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!data?.id) {
      setError("Déclaration introuvable");
      setIsLoading(false);
      return;
    }

    if (data?.payed === 'ongoing' && data?.paymentMethod === 'CB') {
      setError("Un paiement CB est déjà en cours pour cette déclaration. Veuillez patienter la confirmation.");
      setIsLoading(false);
      return;
    }

    initWorldlinePayment();
  }, []);

  const initWorldlinePayment = () => {
    axios
      .get(`${BACKEND_URL}/api/worldline/create-payment/${data.id}`, {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
      .then((res) => {
        const { redirectUrl, hostedCheckoutId, orderId } = res.data;

        if (!redirectUrl) {
          throw new Error("URL de redirection manquante");
        }

        // Rediriger vers WorldLine Hosted Checkout
        // Pas besoin de setIsLoading(false) car on quitte la page
        window.location.href = redirectUrl;
      })
      .catch((error) => {
        // Ignorer les erreurs d'annulation qui surviennent lors de la redirection
        if (error.code === 'ECONNABORTED' || error.code === 'ERR_CANCELED') {
          console.log('Redirection vers WorldLine en cours...');
          return; // Ne rien faire, c'est normal
        }

        // Afficher uniquement les vraies erreurs
        console.error("Erreur lors de l'initialisation du paiement:", error);
        const errorMessage =
          error.response?.data?.error ||
          error.response?.data?.message ||
          "Une erreur est survenue lors de l'initialisation du paiement";
        setError(errorMessage);
        setIsLoading(false);
      });
  };

  const errorDisplay = (
    <Alert
      type="error"
      message={error && <p>{error}</p>}
      className="error-display"
    />
  );

  return (
    <div className="block-right">
      <div className="declaration-payment-page">
        <h2 style={styles.title}>Paiement par Carte Bancaire</h2>
        <div>
          <div style={styles.infoDiv}>
            Somme à payer : <b>{data?.feeAmountLocale}</b>
          </div>
          {!error && (
            <>
              <p>
                Vous allez être redirigé vers la plateforme de paiement
                sécurisée. Veuillez patienter...
              </p>
              <Spin spinning={isLoading} />
            </>
          )}
        </div>
        {error && errorDisplay}
        {error && (
          <div style={styles.buttonDiv}>
            <ButtonLink
              to={"/declaration-certificate-payment"}
              state={{ message: data }}
              children="Retour"
            />
          </div>
        )}
      </div>
    </div>
  );
}

DeclarationCBPageV2.propTypes = {
  // Props passed via location state
  state: PropTypes.shape({
    message: PropTypes.shape({
      id: PropTypes.number.isRequired,
      feeAmountLocale: PropTypes.string,
    }),
  }),
};
